import React, { useContext, useEffect, useState, useCallback, useRef } from "react";
import {
  Box, Typography, TextField, IconButton, Avatar, Divider, Tabs, Tab, Paper,
  Grid
} from "@mui/material";
import { Send, Search } from "@mui/icons-material";
import profilePic from "../../Assets/mentorImg1.png";
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { AuthUser } from '../../interfaces/Contexts';
import {
  getallGroup,
  getNetworks,
  GetRecentMessages,
  getCommonChatRoom,
  createChatRoom,
  getBasicProfileSetting,
  getChatRoom
} from '../../Utils/apiService';
import { format, parseISO } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import SockJS from 'sockjs-client';
import { TURBOVERSE_SOCKET_URL } from '../../Utils/constants';
import { Stomp } from '@stomp/stompjs';
import KenLoader from '../../GlobalComponents/KenLoader';
import { useStyles } from './style';
import Picker from "@emoji-mart/react";
import { useTheme, useMediaQuery } from '@mui/material';
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import ChatIcon from '@mui/icons-material/Chat';

const Chats = () => {
  const classes = useStyles();
  const {
    state: { user }
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [selectedChat, setSelectedChat] = useState<any>(null);
  const [chatMessages, setChatMessages] = useState<any[]>([]);
  const [newMessage, setNewMessage] = useState("");
  const [networkChat, setNetworkChat] = useState<any[]>([]);
  console.log(networkChat, "networkChatnetworkChatnetworkChat");
  const idTokens=localStorage.getItem('user');
  const idToken=JSON.parse(idTokens || '{}');
  const [groupChats, setGroupChats] = useState<any[]>([]);
  const [expandedMessages, setExpandedMessages] = useState<{ [key: number]: boolean }>({});
  const [stompClient, setStompClient] = useState<any>(null);
  const [chatRoomId, setChatRoomId] = useState<string | null>(null);
  const [profileUrl, setProfileUrl] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const messagesContainerRef = useRef<HTMLDivElement>(null);

  // === Fetch Profile Picture & Network ===
  useEffect(() => {
    getBasicProfileSetting(userData?.applicantId).then((res) => {
    });

    fetchNetworkChats();
  }, [userData?.applicantId]);

  const fetchNetworkChats = async () => {
    setLoading(true);
    try {
      // Fetch chat rooms and networks in parallel
      const [chatRoomRes, networksRes] = await Promise.all([
        getChatRoom(userData?.applicantId),
        getNetworks(userData?.applicantId)
      ]);
      const chatRooms = chatRoomRes?.data?.data || [];
      
    const networks: any = JSON.parse(networksRes?.data)?.con
  ?.filter((network: { isConnected: any; }) => network.isConnected) || [];

console.log(networks, 'networks');

      // Helper: find last message for a network user
      const getLastMessageForUser = (networkUserId: string) => {
        // Find a chat room where participants include both userData.applicantId and networkUserId
        const room = chatRooms.find((room: any) => {
          const participantIds = Object.keys(room.participants || {});
          return (
            participantIds.includes(userData.applicantId) &&
            participantIds.includes(networkUserId)
          );
        });
        return room?.lastMessage?.content || "";
      };

      const formatted = networks.map((chat: any) => ({
        id: chat.Id,
        name: chat.Name,
        message: getLastMessageForUser(chat.Id),
        time: "Just now",
        avatar: chat.Profile_Picture_URL__c || "https://via.placeholder.com/40",
        isOnline: chat.Ken_Alumni_CRM__r?.records?.[0]?.Is_Logged_In__c || false,
      }));
      setNetworkChat(formatted);
    } catch (error) {
      console.error("Error fetching network:", error);
    }
    setLoading(false);
  };

  // === Fetch Groups ===
const fetchGroups = async () => {
  setLoading(true);

  try {
    const [chatRoomRes, groupRes] = await Promise.all([
      getChatRoom(userData?.applicantId),
      getallGroup(userData?.applicantId),
    ]);

    const chatRooms = chatRoomRes?.data?.data || [];
    const memberGroups = groupRes?.data?.data?.memberGroups || [];

    // Step 1: Build a map of all member IDs to their profile pics
    const memberIdToProfilePic: Record<string, string> = {};
    memberGroups.forEach((group: any) => {
      const members = group?.Group_Members__r?.records || [];
      console.log(members, 'members in group');
      
      members.forEach((m: any) => {
        const id = m?.Alumni_Member__r?.Id;
        const pic = m?.Alumni_Member__r?.Profile_Picture_URL__c;
        console.log(`Member ID: ${id}, Profile Pic: ${pic}`);
        
        if (id) {
          memberIdToProfilePic[id] = pic || "https://via.placeholder.com/40"; // fallback
        }
      });
    });

    // Helper: get last message for a chat room
    const getLastMessageForGroup = (chatRoomId: string) => {
      const room = chatRooms.find((room: any) => room.id === chatRoomId);
      return room?.lastMessage || null;
    };

    // Step 2: Map groups to include avatar for the last message's receiver
    const memberGroupsData = memberGroups.map((group: any) => {
      const lastMessage = getLastMessageForGroup(group.ChatRoomId__c);
      console.log(`Last Message for group ${group.Id}:`, lastMessage);
      
      // Default avatar
      let avatar: string = "https://via.placeholder.com/40"; 

      // Check if applicant is in the group and is the sender or receiver
      const memberInGroup = group?.Group_Members__r?.records?.find((member: any) => member?.Alumni_Member__r?.Id === userData?.applicantId);
      console.log(`Checking if applicant is in group ${group.Id}:`, memberInGroup);
      
      if (lastMessage?.receiverId) {
        // Find the receiver from the group members
        const receiver = group?.Group_Members__r?.records?.find((m: any) => m?.Alumni_Member__r?.Id === lastMessage?.receiverId);
        console.log(`Receiver found for last message:`, receiver);
        
        if (receiver) {
          // If the receiver is the applicant, use applicant's profile picture
          if (receiver?.Alumni_Member__r?.Id === userData?.applicantId) {
            console.log(`Applicant is the receiver. Using applicant's profile pic.`);
            avatar = userData?.Profile_Picture_URL__c || "https://via.placeholder.com/40"; // Use applicant's pic if it's the applicant
          } else {
            console.log(`Receiver is another member. Using their profile pic.`);
            avatar = receiver?.Alumni_Member__r?.Profile_Picture_URL__c || avatar; // Use receiver's pic if it's another member
          }
        }
      } else {
        // If no last message receiver, fallback to the cover image if available
        console.log(`No receiver for last message. Using cover image or default.`);
        avatar = group?.Cover_Image_Url__c || avatar;
      }

      return {
        groupName: group.Title__c,
        id: group.Id,
        ChatRoomId__c: group.ChatRoomId__c,
        avatar,
        message: lastMessage?.content || "",
        senderId: lastMessage?.senderId || "",
        senderName: lastMessage?.senderName || "",
        receiverId: lastMessage?.receiverId || "",
      };
    });

    setGroupChats(memberGroupsData);
    console.log("Groups with receiver profile pics:", memberGroupsData);

  } catch (err) {
    console.error("Error fetching groups:", err);
  } finally {
    setLoading(false);
  }
};
  // === Handle Tab Switch ===
  const handleTabChange = (event: any, newValue: number) => {
    setNetworkChat([]);
    setGroupChats([]);
    setTabValue(newValue);
    setSelectedChat(null);
    setSearchTerm('');
    setChatMessages([]);
    setNewMessage("")

    if (newValue === 0) {
      fetchNetworkChats();
    } else {
      fetchGroups();
    }
  };

  // === Current List Filtering ===
  const currentChatList = (tabValue === 0 ? networkChat : groupChats).filter((item) => {
    const target = item.name || item.groupName;
    return target?.toLowerCase().includes(searchTerm.toLowerCase());
  });
  console.log(currentChatList, "currentChatListcurrentChatListcurrentChatListcurrentChatList");

  // === Chat Room Creation ===
  const fetchOrCreateChatRoom = useCallback(async () => {
    if (!selectedChat?.id) return;
    setLoading(true);
    try {
      const chatRoom: any = await getCommonChatRoom(userData.applicantId, selectedChat.id);

      if (chatRoom?.data?.data?.length === 0) {
        const payload = {
          name: 'p2p chat',
          participantIds: [userData.applicantId, selectedChat.id],
          adminId: userData.applicantId,
        };

        const createRoomResponse = await createChatRoom(payload);
        if (createRoomResponse?.data?.success) {
          const createdChatRoom = createRoomResponse.data.data;
          setChatRoomId(createdChatRoom.id);
        } else {
          throw new Error('Chat room creation failed');
        }
      } else {
        setChatRoomId(chatRoom.data.data[0]?.id);
      }
    } catch (error) {
      console.error('Chat room error:', error);
    }
    setLoading(false);
  }, [userData.applicantId, selectedChat]);

  // === Chat Room Setup ===
  useEffect(() => {
    if (!selectedChat) return;
    if (tabValue === 0) {
      fetchOrCreateChatRoom();
    } else {
      setChatRoomId(selectedChat?.ChatRoomId__c);
    }
  }, [selectedChat, tabValue, fetchOrCreateChatRoom]);

  // === WebSocket Connection ===
  useEffect(() => {
    if (!chatRoomId) return;

    const socket = new SockJS(TURBOVERSE_SOCKET_URL);
    const client = Stomp.over(socket);

    client.connect({}, () => {
      setStompClient(client);
      const subscription = client.subscribe(`/topic/chatRoom/${chatRoomId}`, (message: any) => {
        const receivedMessage = JSON.parse(message.body);
        setChatMessages((prevMessages) => [...prevMessages, receivedMessage]);
      });

      return () => {
        subscription.unsubscribe();
        client.disconnect();
      };
    });

    return () => {
      client.disconnect();
    };
  }, [chatRoomId]);

  // === Fetch Messages on ChatRoom Change ===
  useEffect(() => {
    if (!chatRoomId) return;
    const fetchMessages = async () => {
      setLoading(true);
      try {
        const response = await GetRecentMessages(chatRoomId, 1, 20);
        setChatMessages(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
      setLoading(false);
    };

    fetchMessages();
  }, [chatRoomId]);

  // Scroll to bottom when messages load (to show recent messages)
useEffect(() => {
  if (chatMessages.length > 0 && messagesContainerRef.current) {
    // Small delay to ensure messages are rendered
    setTimeout(() => {
      if (messagesContainerRef.current) {
        messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
      }
    }, 100);
  }
}, [chatMessages]); // This effect will run whenever chatMessages changes


  // Function to scroll to bottom (for new messages)
const scrollToBottom = () => {
  if (messagesContainerRef.current) {
    messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
  }
};

// Call scrollToBottom when a new message is added
useEffect(() => {
  if (chatMessages.length > 0) {
    scrollToBottom();  // Scroll to bottom when chatMessages change
  }
}, [chatMessages]);


  // === Helpers ===
  const formatDate = (timestamp: string) => format(parseISO(timestamp), 'MMMM d, yyyy');

  const groupMessagesByDate = (messages: any[]) => {
    const grouped: { [key: string]: any[] } = {};
    messages.forEach((message) => {
      const dateLabel = formatDate(message.timestamp);
      if (!grouped[dateLabel]) grouped[dateLabel] = [];
      grouped[dateLabel].push(message);
    });
    return grouped;
  };

  const handleSendMessage = () => {
    if (!newMessage.trim() || !stompClient || !chatRoomId) return;

const messagePayload = {
  content: newMessage.trim(),
  senderId: userData.applicantId,
  chatRoomId,
  attachmentUrl: null,
  timestamp: new Date().toISOString(),
  userName: userData?.applicantName,
  profileUrl: profileUrl || userData?.Profile_Picture_URL__c || null, 
};

    console.log(messagePayload, 'messagePayload');
    stompClient.send('/app/sendMessage', { Authorization: `Bearer ${idToken?.turbosendToken?.idToken}` }, JSON.stringify(messagePayload));
    setNewMessage('');
    
    // Scroll to bottom to show the new message
    setTimeout(() => {
      scrollToBottom();
    }, 100);
  };

  const groupedMessages = groupMessagesByDate(chatMessages);
 const sortedDateKeys = Object.keys(groupedMessages);

  // ================================
  // 🔥 FINAL REQUIRED FIX STARTS HERE
  // ================================

  // 1️⃣ Sort messages inside each date group → oldest → newest
  Object.keys(groupedMessages).forEach((date) => {
    groupedMessages[date].sort(
      (a, b) =>
        new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
    );
  });

  // 2️⃣ Sort the date groups themselves → oldest → newest
  sortedDateKeys.sort(
    (a, b) => new Date(a).getTime() - new Date(b).getTime()
  );


  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleChatSelection = (chat: any) => {
    if (isMobile) {
      navigate(`/chats/${chat.id}`, { state: { chat } });
    } else {
      if (selectedChat?.id !== chat.id) {
        setSelectedChat(chat);
        setNewMessage("");
        setChatMessages([]);
        setChatRoomId(null);
      }
    }
  };
  const getTime = (dateStr: string) => {
    const date = new Date(dateStr);
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };
 

  return (
    <Box sx={{ p: 1, bgcolor: "white", borderRadius: 2, minHeight: '81vh', width: '100%' }}>
      {loading && <KenLoader />}
      <Box sx={{ display: 'flex', gap: '8px', flexDirection: isMobile ? 'column' : 'row', minHeight: '79vh' }}>
        {/* Left Panel */}
        <Box sx={{
          border: isMobile ? 'null' : '1px solid #E7E7E7', borderRadius: 2, p: isMobile ? 1 : 2, borderRight: 'none', width: {
            xs: '100%',
            sm: '50%',
            md: '50%',
          }
        }}>
          <Tabs value={tabValue} onChange={handleTabChange} variant="fullWidth" sx={{ mb: 2 }}>
            <Tab label="Network" />
            <Tab label="Groups" />
          </Tabs>
          <TextField
            fullWidth
            key={tabValue}
            size="small"
            variant="standard"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: <Search sx={{ color: "#8C8E94", mr: 1 }} />,
              disableUnderline: true,
              sx: { fontSize: "14px", p: 1, fontFamily: "Figtree, sans-serif" },
            }}
            sx={{ mb: 2, border: '1px solid #E7E7E7', borderRadius: 2 }}
          />
          <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column', height: '64vh', overflowY: 'auto' }}>
            {currentChatList.map((chat) => (
              <Box
                key={chat.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: 1,
                  borderRadius: 2,
                  cursor: "pointer",
                  bgcolor: "#F6F8FB",
                  border: selectedChat?.id === chat.id ? '1px solid #2C58E8' : 'none',
                }}
                onClick={() => handleChatSelection(chat)} // Use the new handler
              >
                <Box sx={{ position: 'relative', display: 'inline-block' }}>
                  <Avatar src={chat.avatar || profilePic} />
                  {chat?.isOnline === true && (
                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 2,
                        right: -1,
                        width: 12,
                        height: 12,
                        bgcolor: '#44b700',
                        borderRadius: '50%',
                        border: '2px solid white',
                        zIndex: 1,
                      }}
                    />
                  )}
                </Box>
                <Box sx={{ ml: 3, flexGrow: 1, textAlign: 'left' }}>
                  <Typography>{chat.name || chat.groupName}</Typography>
                  <Typography
                    sx={{
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}
                  >
                    {chat.message || 'No messages yet'}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Right Panel */}
        {!isMobile && (
          <Box sx={{ display: "flex", flexDirection: "column", borderRadius: 2, p: 2, border: '1px solid #E7E7E7', width: '100%', height: '82.3vh ' }}>
            {selectedChat && (
              <>
                <Box sx={{ display: "flex", alignItems: "center", pb: 1, borderBottom: "1px solid #E0E0E0", gap: 2 }}>
                  <Avatar src={selectedChat.avatar || profilePic} />
                  <Typography>{selectedChat.name || selectedChat.groupName}</Typography>
                </Box>
                <>
                  {
                    sortedDateKeys.length > 0 ?
                      <Box 
                        ref={messagesContainerRef}
                        sx={{ 
                          height: '70vh', 
                          overflowY: 'auto',
                          display: 'flex',
                          flexDirection: 'column',
                          // Hide scrollbar for Firefox
                          scrollbarWidth: 'none',
                          // Hide scrollbar for Chrome, Safari and Opera
                          '&::-webkit-scrollbar': {
                            display: 'none',
                          },
                        }}
                      >
                  {sortedDateKeys.length > 0 ? (
  <Box
    ref={messagesContainerRef}
    sx={{
      height: '70vh',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column', // normal order
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    }}
  >
    {sortedDateKeys.map((date, index) => (
      <Box key={`date-${index}`}>
        <Box sx={{ textAlign: "center", color: "#777", fontSize: "12px", my: 1 }}>
          {date}
        </Box>
        {groupedMessages[date].map((msg, messageIndex) => (
          <Box
            key={messageIndex}
            sx={{
              display: "flex",
              alignItems: "end",
              py: 1,
              justifyContent:
                msg.senderId === userData.applicantId ? "flex-end" : "flex-start",
              gap: 1,
            }}
          >
            {msg.senderId !== userData.applicantId && (
              <Avatar
                src={msg.profileUrl || profilePic}
                sx={{ width: "30px", height: "30px" }}
              />
            )}

 <div style={{ position: 'relative' }}>
  {/* Message Paper */}
  <Paper
    sx={{
      p: 1,
      borderRadius: 1,
      bgcolor: msg.senderId === userData.applicantId ? "#5981FF" : "#F1F1F1",
      color: msg.senderId === userData.applicantId ? "white" : "#38151D",
      display: 'flex',
      justifyContent: msg.senderId === userData.applicantId ? 'flex-end' : 'flex-start', // Align message text
    }}
  >
    <span>{msg.content}</span>
  </Paper>

  {/* Time Typography */}
  <Typography
    variant="caption"
    sx={{
      color: "#888",
      fontSize: "12px",
      position: 'absolute', // Position the time absolutely in the corner
      bottom: 39,
      left:0, // Adjust this value for margin from the message
     
      textAlign: 'right', // Align the time to the right
      mt: 0.5,
    }}
  >
    {msg.senderId === userData.applicantId && <span>You, </span>}
    {getTime(msg.timestamp)}
  </Typography>
</div>


            {msg.senderId === userData.applicantId && (
              <Avatar
                src={profileUrl || profilePic}
                sx={{ width: "30px", height: "30px" }}
              />
            )}
          </Box>
        ))}
      </Box>
    ))}
  </Box>
) : (
  <Box
    sx={{
      flexGrow: 1,
      overflowY: "auto",
      maxHeight: "70vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    }}
  >
    <ChatIcon sx={{ color: "#A0B6FF", width: "48px", height: "48px" }} />
    <Typography>Start a conversation</Typography>
  </Box>
)}

                      </Box>
                      :
                      <Box sx={{
                        flexGrow: 1, overflowY: "auto", maxHeight: "70vh", display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                      }}>
                        <ChatIcon sx={{ color: "#A0B6FF", width: '48px', height: '48px' }} />
                        <Typography>Start a conversation</Typography>
                      </Box>
                  }
                </>
                <Divider />
                <Box sx={{ display: "flex", alignItems: "center", mt: 2, gap: 1 }}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="standard"
                    placeholder="Type a message..."
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' && !event.shiftKey) {
                        handleSendMessage(); // Call handleSendMessage when Enter is pressed
                        event.preventDefault(); // Prevent default behavior (e.g., form submission)
                      }
                    }}
                    InputProps={{ disableUnderline: true }}
                    sx={{ border: '1px solid #E7E7E7', borderRadius: 2, marginRight: 1, padding: 2 }}
                  />
                  {showEmojiPicker && (
                    <Box sx={{ position: 'absolute', bottom: '14%', right: '5%', zIndex: 1000 }}>
                      <Picker
                        onEmojiSelect={(emoji: { native: string }) => {
                          setNewMessage((prev) => prev + emoji.native); // Append emoji to the message
                        }}
                      />
                    </Box>
                  )}
                  <IconButton onClick={() => setShowEmojiPicker((prev) => !prev)}>
                    <EmojiEmotionsOutlinedIcon />
                  </IconButton>
                  <IconButton color="primary" onClick={handleSendMessage}>
                    <Send />
                  </IconButton>
                </Box>
              </>
            )}
          </Box>
        )}
      </Box>
    </Box >
  );
};

export default Chats;